import { gql, useQuery } from '@apollo/client'


export interface ShopDeviceFiltersQuery {
  shopDeviceFilters: {
    deviceTypes: string[]
    deviceModels: string[]
    deviceOs: string[]
    deviceOsVersions: string[]
    deviceAppVersions: string[]
  }
}

export const GQL_QUERY_SHOP_DEVICE_FILTERS = gql`
  query shopDeviceFilters {
    shopDeviceFilters {
      deviceTypes
      deviceModels
      deviceOs
      deviceOsVersions
      deviceAppVersions
    }
  }
`

export const useFetchShopDeviceFilters = () => useQuery<ShopDeviceFiltersQuery>(
  GQL_QUERY_SHOP_DEVICE_FILTERS,
  {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  }
)